module.exports = {
  pageSize: 20,
  sort: {
    key: 'id',
    order: 'descend',
    ORDER: 'DESC',
  },
};
